<template>
  <div class="rule-modal">
    <van-overlay :show="visible" :lock-scroll="true" :z-index="300">
      <div class="wrapper" @click.stop>
        <div class="content" @touchmove.stop>
          <div class="rule-h2">一、活动入口和权益领取路径</div>
          <section class="rule-block">
            <p class="rule-p">手机银行APP-活动中心-财富晋升计划</p>
          </section>

          <div class="rule-h2">二、活动规则</div>
          <section class="rule-block">
            <div class="rule-h4">1、活动对象</div>
            <p class="rule-p">2026年4月1日前开立借记卡一类户的客户</p>
            <div class="rule-h4">2、活动时间</div>
            <p class="rule-p">（1）活动报名时间：2026年4月10日-2026年6月30日</p>
            <p class="rule-p">（2）权益领取时间：</p>
            <p class="rule-p">
              4月达标客户（2026年4月30日前报名）可于2026年5月5日-5月31日领取，<span class="rule-em rule-em--accent">超期未领不予补发</span>；
            </p>
            <p class="rule-p">
              5月达标客户（2026年5月31日前报名）可于2026年6月5日-6月30日领取，<span class="rule-em rule-em--accent">超期未领不予补发</span>；
            </p>
            <p class="rule-p">
              6月达标客户（2026年6月30日前报名）可于2026年7月5日-7月31日领取，<span class="rule-em rule-em--accent">超期未领不予补发</span>。
            </p>
            <div class="rule-h4">3、活动内容</div>
            <p class="rule-p">
              客户在活动当月进入活动页面完成报名，且4、5、6月月综合贡献值较上月提升达相应档位，即有机会领取对应奖励。<span class="rule-em rule-em--red">每月礼品数量有限，先到先得，领完为止。</span>各档位奖品不可重复获取。具体档位及奖励如下：
            </p>
            <p class="rule-p">
              （1）第1档可在以下权益三选一：25元微信立减金、25元京东e卡、1288积分商城积分，<span class="rule-em rule-em--red">共4029份</span>。
            </p>
            <p class="rule-p">
              （2）第2档可在以下权益三选一：60元微信立减金、60元京东e卡、3088积分商城积分，<span class="rule-em rule-em--red">共1032份</span>。
            </p>
            <p class="rule-p">
              （3）第3档可在以下权益三选一：80元微信立减金、80元京东e卡、4088积分商城积分，<span class="rule-em rule-em--red">共1011份</span>。
            </p>
            <p class="rule-p">
              （4）第4档可在以下权益三选一：120元微信立减金、120元京东e卡、6088积分商城积分，<span class="rule-em rule-em--red">共222份</span>。
            </p>
            <p class="rule-p">
              （5）第5档可在以下权益三选一：200元微信立减金、200元京东e卡、10088积分商城积分，<span class="rule-em rule-em--red">共132份</span>。
            </p>
            <p class="rule-p">
              （6）第6档可在以下权益三选一：400元微信立减金、400元京东e卡、20088积分商城积分，<span class="rule-em rule-em--red">共96份</span>。
            </p>
            <p class="rule-p rule-p--strong">注：</p>
            <p class="rule-p rule-p--strong">
              （1）活动期间每个报名客户每月最多领取1次，活动期间最多领取3次。
            </p>
            <p class="rule-p rule-p--strong">
              （2）综合贡献值计算规则：Σ客户当月每日金融资产/当月总天数。
            </p>
            <p class="rule-p rule-p--strong">
              （3）具体综合贡献值档位标准请咨询您的专属客户经理或拨打我行客服热线。
            </p>
            <p class="rule-p rule-p--strong">
              （4）权益领取路径：厦门国际银行APP-活动中心-二季度财富晋升计划
            </p>
          </section>

          <div class="rule-h2">三、权益使用说明</div>
          <section class="rule-block">
            <div class="rule-h3">（一）微信立减金</div>
            <p class="rule-p">
              1、微信立减金领取后10天有效，有效期以微信卡包显示为准，过期不补。
            </p>
            <p class="rule-p">
              2、使用厦门国际银行借记卡进行微信支付满足立减金消费门槛自动抵扣，具体使用范围以实际抵扣为准。
            </p>
            <p class="rule-p">
              3、享受优惠的订单，如发生全额退款，且立减金仍在有效期内，立减金将自动退还给用户。如发生部分退款，用户支付金额将按比例原路退还，立减金将按比例退还给用户，用户可继续使用。如立减金已过期，则不退还给用户。
            </p>
            <p class="rule-p">
              4、立减金仅限商业支付时使用，社交支付（如转账、红包、个人收款码支付等）不可用。不可使用商户：肯德基、必胜客、CoCo奶茶、Five Plus、Miss Sixty、ochirly、CovenGarden、Denham、孩子王、热风、太平鸟、优衣库、广东电信、星巴克、珠海城建、航联、微众银行、分付、零钱通、理财通、信用卡还款、腾安基金、哔哩哔哩、华为商城、北京市医院管理中心等。合单支付（微信支付订单号为44开头的交易）无法使用立减金；中国境外商户无法使用立减金。
            </p>
            <p class="rule-p">
              5、本券不找零，不可兑换为现金，不可转让，优惠金额部分不开具发票。
            </p>
            <p class="rule-p">
              6、同一微信号、同一手机号、同一身份证号、同一设备号等，符合其中任意条件视为同一用户。
            </p>
          </section>

          <section class="rule-block">
            <div class="rule-h3">（二）京东E卡</div>
            <p class="rule-p">1、打开京东APP，右下角点击“我的”。</p>
            <p class="rule-p">2、打开我的钱包，点击“礼品卡”。</p>
            <p class="rule-p">3、点击右下角“绑定新卡”。</p>
            <p class="rule-p">4、输入卡密绑定，输入卡密即可查询余额或者绑定。</p>
            <p class="rule-p">5、绑定之后回到主界面即可看到账户已经有了一张e卡。</p>
            <p class="rule-p">6、京东e卡只能用来购买自营商品。</p>
            <p class="rule-p">
              7、在下单时选择自营商品，即可在结算界面看到礼品卡处出现“可用”字样，点击使用即可抵扣金额。
            </p>
          </section>

          <div class="rule-h2">四、温馨提示</div>
          <section class="rule-block">
            <p class="rule-p">
              （一）参与默认规则：参与活动即视为同意活动规则，提醒参与者提前仔细阅读。
            </p>
            <p class="rule-p">
              （二）免责声明：因客户操作不当或网络、运营商故障等非银行可控原因致无法参与活动，我行不予负责。
            </p>
            <p class="rule-p">
              （三）规则变动权：银行可依活动实际情况，在法律允许范围内变动调整活动规则，并通过手机银行客户端、银行公众号公布，公布后即时生效。
            </p>
            <p class="rule-p">
              （四）支持与客服：本活动由易点生活电子商务有限公司支持。领取有问题工作日9:00-21:00拨打400-662-7299；其他疑问每日8:30-20:00拨打厦门国际银行客服热线956085。
            </p>
          </section>
        </div>
        <div class="close-btn" @click="onClose">
          <span class="x">×</span>
        </div>
      </div>
    </van-overlay>
  </div>
  <!-- 细则弹框组件 -->
</template>

<script>
export default {
  name: "RuleModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClose() {
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="less" scoped>
.rule-modal {
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    // padding-top: 70px;
    box-sizing: border-box;
  }

  .content {
    background: #fff;
    border-radius: 18px;
    padding: 20px 18px 22px;
    box-sizing: border-box;
    color: #1a1a1a;
    width: 88%;
    max-width: 360px;
    margin: 0 auto;
    flex: 0 1 auto;
    min-height: 0;
    max-height: min(60vh, calc(100dvh - 120px));
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain;
    touch-action: pan-y;
    position: relative;
    z-index: 1;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  }

  .rule-h1 {
    font-size: 18px;
    font-weight: 700;
    color: #111;
    text-align: center;
    margin-bottom: 12px;
  }

  .rule-h2 {
    font-size: 16px;
    font-weight: 700;
    color: #111;
    margin: 18px 0 10px;
    line-height: 1.35;

    &:first-of-type {
      margin-top: 0;
    }
  }

  .rule-block {
    margin-bottom: 4px;
  }

  .rule-h3 {
    font-size: 15px;
    font-weight: 700;
    color: #111;
    margin: 14px 0 8px;
    line-height: 1.4;
  }

  .rule-h4 {
    font-size: 14px;
    font-weight: 600;
    color: #222;
    margin: 12px 0 6px;
    line-height: 1.4;
  }

  .rule-p {
    margin: 0 0 8px;
    font-size: 12px;
    line-height: 1.65;
    color: #333;
    text-align: justify;

    &--mt {
      margin-top: 4px;
    }

    &--strong {
      font-weight: 600;
      color: #222;
    }
  }

  .rule-em {
    font-weight: inherit;

    &--accent {
      color: #e54c5e;
    }

    &--red {
      color: #ff0000;
    }
  }

  .close-btn {
    margin-top: 16px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.25);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    .x {
      font-size: 20px;
      color: #fff;
      line-height: 30px;
      display: block;
    }
  }
}
</style>
